var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChannelManager(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6999 5.68373L11.8999 2.3254C10.5915 1.40873 8.5832 1.45873 7.32487 2.43373L3.14987 5.69206C2.31654 6.34206 1.6582 7.6754 1.6582 8.7254V14.4754C1.6582 16.6004 3.3832 18.3337 5.5082 18.3337H14.4915C16.6165 18.3337 18.3415 16.6087 18.3415 14.4837V8.83373C18.3415 7.70873 17.6165 6.3254 16.6999 5.68373ZM14.0665 11.1671C14.0665 11.4921 13.8082 11.7504 13.4832 11.7504C13.1582 11.7504 12.8999 11.4921 12.8999 11.1671V11.0171L10.6332 13.2837C10.5082 13.4087 10.3415 13.4671 10.1665 13.4504C9.99987 13.4337 9.84154 13.3337 9.74987 13.1921L8.89987 11.9254L6.91654 13.9087C6.79987 14.0254 6.6582 14.0754 6.5082 14.0754C6.3582 14.0754 6.2082 14.0171 6.09987 13.9087C5.87487 13.6837 5.87487 13.3171 6.09987 13.0837L8.5832 10.6004C8.7082 10.4754 8.87487 10.4171 9.04987 10.4337C9.22487 10.4504 9.3832 10.5421 9.47487 10.6921L10.3249 11.9587L12.0832 10.2004H11.9332C11.6082 10.2004 11.3499 9.94206 11.3499 9.61706C11.3499 9.29206 11.6082 9.03373 11.9332 9.03373H13.4832C13.5582 9.03373 13.6332 9.0504 13.7082 9.0754C13.8499 9.13373 13.9665 9.2504 14.0249 9.39206C14.0582 9.46706 14.0665 9.54206 14.0665 9.61706V11.1671Z",
    fill: "#007FFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChannelManager);
export default __webpack_public_path__ + "static/media/channelManager.e9566c4715e1719583d310dc73bc1b1d.svg";
export { ForwardRef as ReactComponent };